import { render, staticRenderFns } from "./AdminPuzzleNumberConnectorsForm.vue?vue&type=template&id=2f89eaf6"
import script from "./AdminPuzzleNumberConnectorsForm.vue?vue&type=script&lang=js"
export * from "./AdminPuzzleNumberConnectorsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports